import axios from "axios";

export const getCollages = () =>
  new Promise((resolve, reject) => {
    axios
      .get("/wp-json/dpe/v1/collage")
      .then(resp => {
        if (!Array.isArray(resp.data)) {
          reject(new Error("Invalid data format"));
        }
        resolve(resp.data);
      })
      .catch(err => {
        reject(err);
      });
  });

export const saveCollage = (id, title, canvasData) =>
  new Promise((resolve, reject) => {
    axios
      .post("/wp-json/dpe/v1/collage", { id, title, canvasData })
      .then(resp => {
        const id = parseInt(resp.data, 10);
        if (id > 0) {
          resolve(id);
        }
        reject(new Error("Invalid response"));
      })
      .catch(err => {
        reject(err);
      });
  });

export const deleteCollage = id =>
  new Promise((resolve, reject) => {
    axios
      .delete("/wp-json/dpe/v1/collage", { data: { id } })
      .then(resp => {
        resolve();
      })
      .catch(err => {
        reject(err);
      });
  });
